var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-circular',{class:'eg-progress-circle ' + _vm.classes + (_vm.isStepPassed ? ' eg-progress__full' : ''),attrs:{"rotate":-90,"size":36,"width":8,"value":_vm.value,"color":_vm.value > 0 ? _vm.color : _vm.$vuetify.theme.themes.light.background}},[(_vm.value > 0)?_c('span',[_vm._v(_vm._s(_vm.step))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }